import React from 'react';
import Collapse, { Panel } from 'rc-collapse';
import { withTranslation, WithTranslation } from 'react-i18next';

type ChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => void;

interface SpecialSettingsPanelOwnProps {
  // extra.c.c70 — the URL of the next linked question. Also written by the
  // next-target selector, which builds a go.taplause.com link from the picked
  // target, so editing it here is the manual equivalent of that.
  linkingTarget: string;
  onChangeLinkingTarget: ChangeHandler;
  // extra.c.css — free-form style overrides for the public target page.
  css: string;
  onChangeCss: ChangeHandler;
}

const SpecialSettingsPanel = ({
  linkingTarget, onChangeLinkingTarget, css, onChangeCss, t,
}: SpecialSettingsPanelOwnProps & WithTranslation) => (
  <Collapse>
    <Panel header={t('target.editor.special.title')} forceRender={true}>
      <div style={{ height: "0.2em" }}></div>
      <label>{t('target.editor.special.linkingTarget')}</label>
      <input type="text" placeholder="Next linked question URL"
        value={linkingTarget}
        onChange={onChangeLinkingTarget} />
      <div style={{ height: "0.2em" }}></div>

      <label>{t('target.editor.special.styleSettings')}</label>
      <input type="text" placeholder="CSS style settings" data-redisid="stylesetting"
        value={css}
        onChange={onChangeCss} />
      <div style={{ height: "0.2em" }}></div>
    </Panel>
  </Collapse>
);

export default withTranslation('common')(SpecialSettingsPanel);
